export var VER_NUM = "";



//////////////////
// WEBPACK FOOTER
// ./src/config/version.ts
// module id = 207
// module chunks = 0